var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('transition', {
    attrs: {
      "name": "translateY",
      "mode": "out-in"
    }
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isOptionsOpen,
      expression: "isOptionsOpen"
    }],
    staticClass: "InputOptions-options m-0 p-0",
    attrs: {
      "aria-activedescendant": _vm.items[_vm.value],
      "role": "listbox",
      "tabIndex": "-1"
    }
  }, _vm._l(_vm.items, function (item, index) {
    return _c('li', {
      key: ("input_options_" + index),
      staticClass: "InputOptions-option d-flex justify-content-between",
      class: [_vm.isItemSelected(index) ? ("js-input-option-active-" + (_vm.inputId) + " InputOptions-option--active") : '', ("js-input-option-" + (_vm.inputId))],
      style: {
        'backgroundColor': _vm.isItemSelected(index) || _vm.getItemsHovered[_vm.optionsObject ? item.id : item] ? _vm.backgroundColorSelected : '',
        'color': _vm.isItemSelected(index) || _vm.getItemsHovered[_vm.optionsObject ? item.id : item] ? _vm.colorSelected : ''
      },
      attrs: {
        "aria-selected": _vm.isItemSelected(index),
        "role": "option",
        "tabIndex": "0"
      },
      on: {
        "click": function ($event) {
          return _vm.itemSelected(index);
        },
        "blur": function ($event) {
          return _vm.updateHovered(_vm.optionsObject ? item.id : item, false);
        },
        "focus": function ($event) {
          return _vm.updateHovered(_vm.optionsObject ? item.id : item, true);
        },
        "keyup": [function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
          return _vm.itemSelected(index);
        }, function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.itemSelected(index);
        }],
        "keydown": [function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
          $event.preventDefault();
          _vm.toFocus(_vm.next(index));
        }, function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
          $event.preventDefault();
          _vm.toFocus(_vm.previous(index));
        }],
        "mouseleave": function ($event) {
          return _vm.updateHovered(_vm.optionsObject ? item.id : item, false);
        },
        "mouseover": function ($event) {
          return _vm.updateHovered(_vm.optionsObject ? item.id : item, true);
        }
      }
    }, [_vm.withSlotItem ? _vm._t("option", null, {
      "item": item
    }) : [_vm._v(" " + _vm._s(_vm.optionsObject ? item.value : item) + " ")]], 2);
  }), 0)]);
}
var staticRenderFns = []

export { render, staticRenderFns }